import Vue from 'vue'
import { Module, ActionContext } from 'vuex'
import { ConversationAiState, RootState } from '../store/state_models'
import { get, set } from 'lodash'

export const conversationAi: Module<ConversationAiState, RootState> = {
  namespaced: true,
  state: {
    isConversationAiEnabled: undefined,
    trialConversationList: {},
  },
  getters: {
    getTrialConversations: (state: ConversationAiState) => {
      return (locationId: string) =>
        get(state.trialConversationList, locationId)
    },
  },
  mutations: {
    updateConversationList: (
      state: ConversationAiState,
      params: { message: { [key: string]: any }; locationId: string,  thumbVote?:string, index?:any}
    ) => {
      if (state.trialConversationList[params.locationId]) {
        if(params.thumbVote){
          state.trialConversationList[params.locationId][params.index]['thumbVote']= params.thumbVote
        } else {
        state.trialConversationList[params.locationId].push(params.message)
        }
      } else {
        state.trialConversationList = set(
          state.trialConversationList,
          params.locationId,
          []
        )
        state.trialConversationList[params.locationId].push(params.message)
      }
    },
    resetConversationList: (
      state: ConversationAiState,
      params: { locationId: string }
    ) => {
      state.trialConversationList[params.locationId] = []
    },
    updateConversationAi:(state: ConversationAiState,
      payload: { value:boolean }) => {
        state.isConversationAiEnabled = payload.value
    }
  },
  actions: {
    addTrialMessage: (
      context: ActionContext<ConversationAiState, RootState>,
      payload: { message: { [key: string]: any }; locationId: string }
    ) => {
      context.commit('updateConversationList', payload)
    },
    resetConversation: (
      context: ActionContext<ConversationAiState, RootState>,
      payload: { locationId: string }
    ) => {
      context.commit('resetConversationList', payload)
    },
    changeConversationAiEnabling: (context: ActionContext<ConversationAiState, RootState>,
      payload: { value:boolean }) =>{
        context.commit('updateConversationAi', payload)
      },
    updateTrialAuditing: (
      context: ActionContext<ConversationAiState, RootState>,
      payload: { thumbVote: string }    // 'up' 'down'
    ) => {
      context.commit('updateConversationList', payload)
    },
  },
}
